<template>
  <div class="percentage-chart">
    <div>
      <div
        v-for="(val, i) in values"
        :key="i"
        class="percentage-chart__bar text-center pa-2"
        :style="{ width: 100 / values.length + '%' }"
        @click="onClickType(i)"
      >
        <span
          class="color-dot"
          :class="getTypeColor(i)"
        />
        {{ labels[i] }}
        <p class="ma-0 grey--text">
          <small>{{ val | fmtCurrency }}</small>
        </p>
      </div>
      <div style="clear: both" />
    </div>

    <div
      :style="{ height: height + 'px' }"
    >
      <div
        v-for="(val, i) in values"
        :key="i"
        class="percentage-chart__bar text-center"
        :class="getTypeColor(i)"
        :style="{ width: (val / total) * 100 + '%' }"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    colors: {
      type: Array,
      default: () => ['blue', 'deep-orange', 'lime', 'green', 'cyan', 'deep-purple']
    },
    data: {
      type: Object,
      default: () => { return {} }
    },
    height: {
      type: Number,
      default: 5
    },
    value: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      labels: [],
      total: 0,
      values: [],
      model: []
    }
  },
  watch: {
    data () {
      this.drawChart()
    }
  },
  mounted () {
    this.drawChart()
  },
  methods: {
    drawChart () {
      this.values = Object.values(this.data)
      this.total = this.values.reduce((a, b) => a + b, 0)
      this.labels = Object.keys(this.data)
    },
    onClickType (i) {
      const type = this.labels[i]
      const position = this.model.indexOf(type)

      if (position >= 0) {
        this.model.splice(position, 1)
      } else {
        this.model.push(type)
      }

      this.$emit('input', this.model)
    },
    getTypeColor (i) {
      const type = this.labels[i]
      if (this.model.length === 0 || this.model.includes(type)) {
        return this.colors[i]
      } else {
        return 'grey'
      }
    }
  }
}
</script>

<style lang="scss">
.percentage-chart {
  &__bar {
    height: 100%;
    float: left;
  }

  &__bar {
    cursor: pointer;

    &:hover {
      background-color: #eeeeee;
    }
  }

  .color-dot {
    display: inline-block;
    width: 10px;
    height: 10px;
    border-radius: 50%;
  }
}
</style>
